import React from 'react';

const Preview = ({ image, position, name, fontSettings }) => {
  return (
    <div className="mt-6 space-y-4">
      <h3 className="text-lg font-medium text-gray-900">Preview</h3>
      <div className="relative bg-gray-100 rounded-lg p-4">
        <img 
          src={image} 
          alt="Preview" 
          className="w-full h-auto max-h-[400px] object-contain"
        />
        {name && (
          <div
            className="preview-name absolute"
            style={{
              fontFamily: fontSettings.family,
              fontSize: `${fontSettings.size}px`,
              color: fontSettings.color,
              left: `${position.x}%`,
              top: `${position.y}%`,
              transform: 'translate(-50%, -50%)'
            }}
          >
            {name}
          </div>
        )}
      </div>
    </div>
  );
};

export default Preview;